module.exports = __webpack_public_path__ + "static/portrait-small-898c2ffe5f91a398f07a02fe8804028f.jpeg";